export default "__VITE_ASSET__okXQWZIW__"